import { connect } from 'react-redux';
import View from './ProgressBarView';
import {
  labelSelector,
  percentageSelector,
  hasLineSelector,
  hideSelector,
} from './ProgressBarSelector';

const mapStateToProps = (state, ownProps) => ({
  label: labelSelector(state, ownProps),
  percentage: percentageSelector(state, ownProps),
  hasLine: hasLineSelector(state, ownProps),
  hide: hideSelector(state, ownProps),
});

export default connect(mapStateToProps)(View);
